import { PLAY_TYPE_LABELS } from './productConstants';

export function parsePlayConfig(playConfig) {
  if (!playConfig) {
    return {};
  }
  if (typeof playConfig === 'object') {
    return playConfig;
  }
  try {
    return JSON.parse(playConfig);
  } catch {
    return {};
  }
}

export function playTypeLabel(playType) {
  return PLAY_TYPE_LABELS[playType] || playType || '—';
}

/** 狀態：啟用 / 禁用 / 禁止下單 */
export function resolveProductStatus(status, exchangeStatus) {
  const s = Number(status);
  const e = Number(exchangeStatus);
  if (s === 1 && e === 1) {
    return 'enabled';
  }
  if (s === 1 && e === 0) {
    return 'no_order';
  }
  return 'disabled';
}

export function statusDisplayText(status, exchangeStatus) {
  const value = resolveProductStatus(status, exchangeStatus);
  if (value === 'enabled') {
    return '啟用';
  }
  if (value === 'no_order') {
    return '禁止下單';
  }
  return '禁用';
}

export function statusToFields(statusValue) {
  if (statusValue === 'enabled') {
    return { status: 1, exchangeStatus: 1 };
  }
  if (statusValue === 'no_order') {
    return { status: 1, exchangeStatus: 0 };
  }
  return { status: 0, exchangeStatus: 0 };
}

export function statusFilterToParams(filterValue) {
  if (!filterValue) {
    return {};
  }
  return statusToFields(filterValue);
}

export function amountDisplayText(value) {
  const num = Number(value);
  if (value == null || Number.isNaN(num) || num <= 0) {
    return '不限制';
  }
  return String(value);
}

export function feeRateToPercent(rate) {
  const num = Number(rate);
  if (Number.isNaN(num)) {
    return '';
  }
  return (num * 100).toFixed(2);
}

export function percentToFeeRate(percent) {
  const num = Number(percent);
  if (Number.isNaN(num)) {
    return 0;
  }
  return num / 100;
}

export function boolDisplayText(value) {
  return value ? '開啟' : '關閉';
}

export function productToForm(product) {
  const cfg = parsePlayConfig(product?.playConfig);
  return {
    status: resolveProductStatus(product?.status, product?.exchangeStatus),
    sort: product?.sort ?? '',
    marketSymbolCode: product?.marketSymbolCode || '',
    pairLabel: product?.name || '',
    customName: cfg.customName || '',
    showIcon: Boolean(cfg.showIcon),
    conversionRate: cfg.conversionRate != null ? String(cfg.conversionRate) : '1',
    showPricePerGram: Boolean(cfg.showPricePerGram),
    minOrderAmount: product?.minOrderAmount != null ? String(product.minOrderAmount) : '0',
    maxOrderAmount: product?.maxOrderAmount != null ? String(product.maxOrderAmount) : '0',
    handlingFeeRate: feeRateToPercent(product?.handlingFeeRate),
    quickAmounts: cfg.quickAmounts || '',
    quickRatios: cfg.quickRatios || '',
    durationSeconds: cfg.durationSeconds != null ? String(cfg.durationSeconds) : '60',
    payoutOdds: cfg.payoutOdds != null ? String(cfg.payoutOdds) : '1.95',
    defaultLeverage: cfg.defaultLeverage != null ? String(cfg.defaultLeverage) : '20',
    maxLeverage: cfg.maxLeverage != null ? String(cfg.maxLeverage) : '125',
    stakingTime: cfg.stakingTime != null ? String(cfg.stakingTime) : '0',
  };
}

export function buildCreatePayload(form, categoryKey, categories) {
  const category = categories.find((item) => item.key === categoryKey);
  const playType = category?.playType;
  const payload = {
    playType,
    marketSymbolCode: form.marketSymbolCode,
    customName: form.customName || undefined,
    showIcon: form.showIcon,
    conversionRate: Number(form.conversionRate || 1),
    showPricePerGram: form.showPricePerGram,
    minOrderAmount: Number(form.minOrderAmount || 0),
    maxOrderAmount: Number(form.maxOrderAmount || 0),
    handlingFeeRate: percentToFeeRate(form.handlingFeeRate),
    quickAmounts: form.quickAmounts || undefined,
    quickRatios: form.quickRatios || undefined,
  };
  if (category?.assetClass) {
    payload.assetClass = category.assetClass;
  }
  if (category?.commodityOnly) {
    payload.commodityOnly = true;
  }
  if (playType === 'PERPETUAL') {
    payload.defaultLeverage = Number(form.defaultLeverage);
    payload.maxLeverage = Number(form.maxLeverage);
    payload.stakingTime = Number(form.stakingTime || 0);
  }
  return payload;
}

export function buildUpdatePayload(product, form) {
  const cfg = parsePlayConfig(product.playConfig);
  const statusFields = statusToFields(form.status);
  const nextConfig = {
    ...cfg,
    customName: form.customName || '',
    showIcon: form.showIcon,
    conversionRate: Number(form.conversionRate || 1),
    showPricePerGram: form.showPricePerGram,
    quickAmounts: form.quickAmounts || undefined,
    quickRatios: form.quickRatios || undefined,
  };
  const playType = product?.playType;
  if (playType === 'PERPETUAL') {
    nextConfig.defaultLeverage = Number(form.defaultLeverage);
    nextConfig.maxLeverage = Number(form.maxLeverage);
    nextConfig.stakingTime = Number(form.stakingTime || 0);
  }
  return {
    id: product.id,
    playType: product.playType,
    sort: form.sort === '' ? product.sort : Number(form.sort),
    ...statusFields,
    minOrderAmount: Number(form.minOrderAmount || 0),
    maxOrderAmount: Number(form.maxOrderAmount || 0),
    handlingFeeRate: percentToFeeRate(form.handlingFeeRate),
    playConfig: JSON.stringify(nextConfig),
  };
}
